import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=01f02a4c&scoped=true"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"
import style0 from "./SSO.vue?vue&type=style&index=0&id=01f02a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f02a4c",
  null
  
)

export default component.exports